import React from "react";
import { Route, Routes } from "react-router-dom";
import { CouponReportList } from "./containers";

export const CouponReport = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<CouponReportList />} />
      </Routes>
    </>
  );
};
